import { PatientGroupEffect } from '@dreryk/egabinet-patient-frontend-api';

import { TranslateFunction } from '@dreryk/react-common';

import { translationKeys } from '../../translations';

export const formatPatientGroupEffects = (
   patientGroupEffects: PatientGroupEffect[],
   translate: TranslateFunction
): string => {
   return patientGroupEffects
      .map((patientGroupEffect) => translate(translationKeys.patientEffectsMap[patientGroupEffect]))
      .join(', ');
};
